import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Cpu } from "lucide-react";

export const Route = createFileRoute("/integration/profiles")({
  component: ProfilesPage,
});

function ProfilesPage() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <Cpu className="h-5 w-5" /> Profils dispositifs
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">IEEE 11073 · HL7 FHIR Device · Vendor plugins</p>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Profils de connexion</CardTitle>
          <CardDescription>Vendor plugins · Connectors par constructeur</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Chaque dispositif médical expose un profil (vendor, modèle, transport HL7/IEEE).
          L'orchestrateur route les observations vers le bon patient/encounter.
        </CardContent>
      </Card>
    </div>
  );
}
